import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import useScrollShadows from 'main/components/tables/hooks/useScrollShadows';

function sortingClassName(headerViewModel) {
  if (!headerViewModel.sortingAllowed) return '';
  switch (headerViewModel.sort) {
    case 'asc': return 'sorting_asc';
    case 'desc': return 'sorting_desc';
    default: return 'sorting';
  }
}

const TableHeader = observer(({header, horizontalScroll, showShadow, stickyColumnRef, uiState}) => {
  const {className = '', header: label, sticky, translateHeader = true, width} = header.column;
  let headerContent = <span>&nbsp;</span>;
  if (label) {
    headerContent = translateHeader ? <FormattedMessage id={label}/> : label;
  }

  return (
    <th
      className={`${className} ${sortingClassName(header)} ${sticky ? 'sticky-column' : ''} ${sticky && showShadow ? 'sticky-shadow' : ''}`}
      style={horizontalScroll ? {minWidth: `${width * 5}rem`} : {width: `${(width / 12) * 100}%`}}
      ref={sticky ? stickyColumnRef : null}
    >
      <span onClick={() => uiState.clickHeader(header)}>{headerContent}</span>
    </th>
  );
});

const TableHeaders = observer(({showLinks, horizontalScroll, containerRef, uiState}) => {
  const [
    stickyColumnRef,
    showShadow,
    actionLinksRef,
    showActionLinksShadow
  ] = useScrollShadows(horizontalScroll, containerRef);

  return (
    <tr>
      {uiState.headers.map((header, index) => (
        <TableHeader
          key={index}
          header={header}
          horizontalScroll={horizontalScroll}
          showShadow={showShadow}
          stickyColumnRef={stickyColumnRef}
          uiState={uiState}
        />
      ))}
      {showLinks && <th
        className={`${horizontalScroll ? 'action-links-column' : ''} ${horizontalScroll && showActionLinksShadow ? 'sticky-shadow' : ''}`}
        ref={actionLinksRef}
      >
        &nbsp;
      </th>}
    </tr>
  );
});

export default TableHeaders;
